import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";


const OgcsSale = () => {

  const navigate = useNavigate();
  const handleBack = () => navigate(-1);
  const [agree, setAgree] = useState(false);
  const handleAgreeChange = () => setAgree(!agree);
  const handleProceed = () => {
    if (agree) {
      navigate("/sign-in"); // Navigate to Register Page
    }
  };


  return (
    <div className="container mx-auto p-6 text-[10px]  relative bg-gray-100 min-h-screen ">
      {/* Close Button */}
      <button
        onClick={handleBack}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
      >
        <X size={20} />
      </button>

      <h1 className="text-2xl font-bold text-gray-900 mb-6">Sale By BuildPro OGCS </h1>

      <div className="p-6 bg-white shadow-lg rounded-lg">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          Refund Terms and Conditions - Seller Platform
        </h3>

        <div>
          <p className="text-[10px] font-semibold text-gray-700">Convenience Charges by Category and Subcategory</p>
          <h2 className="text-[10px] font-semibold text-gray-700">For Sale By Buildpro-OGCS</h2>
          <ul className="list-disc pl-6 text-gray-600 mb-2">
            <li><strong>Hand Tools</strong>
              <ul className="list-disc pl-6 ">
                <li>Manual hand tool - 6%</li>
                <li>Electrical hand tool - 6%</li>
                <li>Hydraulic hand tool - 6%</li>
              </ul>
            </li>
            <li><strong>Small Equipment</strong>
              <ul className="list-disc pl-6">
                <li>Concrete mixtures - 5%</li>
                <li>Surveying and Measurement Tools - 5%</li>
                <li>Excavation and Digging Tools - 5%</li>
                <li>Compaction and Tamping Tools - 5%</li>
                <li>Finishing and Smoothing Tools - 5%</li>
                <li>Vibrators for Concrete - 5%</li>
              </ul>
            </li>

            <li><strong>Structural Material</strong>
              <ul className="list-disc pl-6">
                <li>Reinforcement steel - 1%</li>
                <li>Epoxy coated rebar - 1%</li>
                <li>Hot Rolled Deformed Bars - 1%</li>
                <li>Cold Rolled Steel Bars-1%</li>
                <li>Mild Steel Bars-1%</li>
                <li>Welded Steel Wire-1%</li>
                <li>Prestressing steel bars-1%</li>
                <li>Rebar</li>
                <li>High yield strength deformed (HYSD) bar-1% </li>
                <li>Structural steel Deferent section and size-1% </li>
                <li>Alloy steel</li>
                <li>Heat-treated carbon steel-1%</li>
              </ul>
            </li>

            <li><strong>Heavy Equipment</strong>
              <ul className="list-disc pl-6">
                <li>Concrete Batching Plants- 4%</li>
                <li>Forklifts and Pallet Jacks - 4%</li>
                <li>Concrete Pumps - 4%</li>
                <li>Boom Placers-4%</li>
                <li>Porta cabin-4%</li>
                <li>Specialized Heavy Equipment's-4%</li>
                <li>Power Trencher-4%</li>
                <li>Transport Equipment-4%</li>
                <li>Plastering and Masonry Equipment-4% </li>
                <li>Cranes-4% </li>
                <li>Concrete Equipment -4%</li>
                <li>Rollers-4%</li>
                <li>Excavators and Loaders-4%</li>
              </ul>
            </li>

            <li><strong>Construction Chemical and Materials</strong>
              <ul className="list-disc pl-6">
                <li>Concrete Hardeners- 5%</li>
                <li>Waterproofing Solutions - 5%</li>
                <li>Surface Treatments- 5%</li>
                <li>Bonding and Adhesive Agents-5%</li>
                <li>Protective Coatings-5%</li>
                <li>Grouts and Repair Mortars-5%</li>
                <li>Admixtures for Concrete -5%</li>
                <li>Insulation Materials -5%</li>
                <li>Tiles and Pavers-5% </li>
                <li>Joints and Panels-5% </li>
                <li>Expansion Joints and Water Stoppers  -5%</li>
                <li>Paint-3%</li>
              </ul>
            </li>

            <li><strong>Bulk Material/Construction Materials</strong>
              <ul className="list-disc pl-6">
                <li>Concrete Block- 5%</li>
                <li>Bricks - 5%</li>
                <li>Fly Ash- 5%</li>
                <li>Masonry Materials-4%</li>
                <li>Bituminous Materials-4%</li>
                <li>Sand and Aggregates-10%</li>
                <li>Cement and Cement Products  -2%</li>


              </ul>
            </li>

            <li><strong>Finishing Items</strong>
              <ul className="list-disc pl-6">
                <li>Rolling Shutters- 5%</li>
                <li>Windows - 5%</li>
                <li>Doors- 5%</li>
                <li>Water Heaters-5%</li>
                <li>Sanitary Fixtures-5%</li>
                <li>Water Supply Fixtures-5%</li>
                <li>Valves -5%</li>
                <li>Pipe Fittings -5%</li>
                <li>Galvanized Steel Pipes-5% </li>
                <li>Copper Pipes-5% </li>
                <li>CPVC Pipes (Chlorinated Polyvinyl Chloride) -5%</li>
                <li>PVC Pipes (Polyvinyl Chloride) -5%</li>
                <li>Industrial Pipefitting & Valves -2%</li>
                {/* <li>Paint-3%</li> */}
              </ul>
            </li>

            <li><strong>Form Work Material </strong>
              <ul className="list-disc pl-6">
                <li>Formwork Panels (Modular)- 5%</li>
                <li>wooden batten- 5%</li>
                <li>Plywood- 5%</li>
                <li>Additional Formwork Components-5%</li>
                <li>Doka Components-5%</li>
                <li>Cup Lock Scaffolding System-5%</li>
                <li>Access Scaffolding  -5%</li>
                <li>HDT System -5%</li>
                <li>Wall/Column Formwork -5% </li>
                <li>Advanced Scaffolding Systems -5% </li>
                <li>Basic Formwork Components -5%</li>

              </ul>
            </li>

            <li><strong>Specialized Equipment's</strong>
              <ul className="list-disc pl-6">
                <li>Dewatering pumps- 4%</li>
                <li>D.G.Sets- 4%</li>
                <li>Specialized Testing Equipment- 4%</li>
                <li>Specialized Equipment-4%</li>
                <li>GPS and Total Stations-4%</li>
                <li>Surveying Instruments-4%</li>
              </ul>
            </li>

            <li><strong>Safety Items</strong>
              <ul className="list-disc pl-6">
                <li>First Aid and Fire Safety Equipment- 5%</li>
                <li>Fall Protection Equipment- 5%</li>
                <li>Personal Protective Equipment (PPE)- 5%</li>

              </ul>
            </li>
            <li>
              <strong>Electrical Materials</strong>
              <ul className="list-disc pl-6">
                <li>Conduits and Fittings- 5%</li>
                <li>Wires and Cables- 7%</li>
                <li>Switches and Sockets- 7%</li>
                <li>Light Fixtures- 7%</li>
                <li>Distribution Boards and- 10%</li>
                <li>Protection Devices </li>
                <li>Earting and Lightning Protection- 10%</li>
                <li>Control Panels and Accessories- 5%</li>
                <li>Communication & Safety- 5%</li>
                <li>Miscellaneous Items- 10%</li>
              </ul>
            </li>
          </ul>
        </div>

        <h4 className="text-[10px] font-semibold text-gray-700">1. Registration Cancellation</h4>
        <p className="text-gray-600 mb-2">
          Sellers or manufacturers who register with BuildPro-OGCS Platform may cancel their registration; however, no refund will be applicable in such cases.
        </p>

        <h4 className="text-[10px] font-semibold text-gray-700">2. Registration Timeframe</h4>
        <p className="text-gray-600 mb-2">
          Registration charges are valid for a period of three years. If a seller does not actively use the platform during this period, they may request an additional one-year grace period by submitting a request letter. The seller can continue their registration after receiving approval for the grace period.
        </p>

        {/* <h4 className="text-[10px] font-semibold text-gray-700">3. Cancellation Before Product Displayed on Platform</h4>
      <p className="text-gray-600 mb-2">
      If a seller wishes to cancel a product or all products before they are displayed on the BuildPro-OGCS platform, a 10% administration charge will be deducted from the total Deposit. The remaining balance will be refunded upon receiving a written cancellation request from the seller.
      </p> */}

        {/* <h4 className="text-[10px] font-semibold text-gray-700">4. Cancellation After Product Displayed on Website</h4>
      <p className="text-gray-600 mb-2">If a product has been displayed on the BuildPro-OGCS platform, the following refund policy will apply for cancellations during the first year:</p>
      <ul className="list-disc pl-6 text-gray-600 mb-2">
        <li>Within 1 week: A 12% deduction from the total Deposit.</li>
        <li>After 1 week but within 3 months: A 50% deduction from the total Deposit.</li>
        <li>After 3 months but within 6 months: A 75% deduction from the total Deposit.</li>
        <li>After 6 months: No refund will be applicable.</li>
      </ul> */}

        <h4 className="text-[10px] font-semibold text-gray-700">3. Cancellation Due to Force Majeure</h4>
        <p className="text-gray-600 mb-2">
          In the case of force majeure events (e.g., product ban by the government or local authorities), no cancellation or refund will be possible. If a product is found to be involved in unlawful activities, BuildPro-OGCS will immediately cancel the listing, and no refund will be issued. The seller is responsible for any legal consequences, charges, fees, penalties, or judgments arising from their product’s involvement in illegal activities.
        </p>

        <h4 className="text-[10px] font-semibold text-gray-700">4. Cancellation of Sale by BuildPro-OGCS Platform</h4>
        <p className="text-gray-600 mb-2">If a seller wishes to cancel one or more products and remove them from the BuildPro-OGCS website, the following terms will apply:</p>
        <ul className="list-disc pl-6 text-gray-600 mb-2">
          <li>Before 1 week: A full deposit refund will be processed within 10 working days upon receipt of a request letter or email from the seller.</li>
          <li>After 1 week but within 6 months: A 50% deposit deduction will apply, and the remaining balance will be refunded within 10 working days after receiving the request letter.</li>
          <li>If a product is sold during this period: Convenience charges as per Convenience charges chart of the product value sold will be deducted in addition to the deposit deduction. But not delivered and Seller wish to cancel the agreement of selling the product through Buildpro-OGCS Platform As against Advertisement and Marketing initiative from Buildpro-OGCS.</li>
          <li>After 6 months:
            <ul className="list-disc pl-6">
              <li>If no sale has occurred, 70% of the deposit will be refunded within 15 working days.</li>
              <li>If the product has been sold, 50% of the deposit will be refunded within 15 working days after receiving a request letter from the seller.</li>

            </ul>
            <li>After 1 year: If the product has not been sold, BuildPro-OGCS will take responsibility and process the 90% Deposit refund within 15 working days upon the completion of one year.</li>
            <li>Non-Delivery of Products: If the seller initiates a buying process but fails to deliver the product to the customer’s address, a 10% penalty will be deducted from the deposit for each canceled order. This penalty is for non-performance of the seller.</li>
          </li>
        </ul>

        <h4 className="text-[10px] font-semibold text-gray-700">5. Payment Terms for Sale by BuildPro-OGCS Module</h4>
        <p className="text-gray-600 mb-2">Once a product is sold, the buyer makes payment to BuildPro-OGCS, including GST. BuildPro-OGCS generates and sends an invoice to the buyer.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">6. Payment to Seller</h4>
        <p className="text-gray-600 mb-2">After delivery confirmation by the buyer, BuildPro-OGCS pays 50% of the product value (including GST) to the seller.
          Second instatement or final payment will be done as per payment schedule.
        </p>

        <h4 className="text-[10px] font-semibold text-gray-700">7. All-Inclusive Pricing</h4>
        <p className="text-gray-600 mb-2">Sellers must provide a final price inclusive of BuildPro-OGCS convenience charges. The buyer will not be charged any additional fees beyond the seller's declared price.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">8. GST</h4>
        <p className="text-gray-600 mb-2">GST is charged separately and is applicable as per prevailing tax laws. The seller’s GST invoice will reflect the GST amount.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">9. Tax Invoices</h4>
        <p className="text-gray-600 mb-2">A tax invoice is issued between the seller and the buyer with BuildPro-OGCS branding for transparency.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">10. Convenience Charges Invoice</h4>
        <p className="text-gray-600 mb-2">The invoice for convenience charges is issued between the seller and BuildPro-OGCS. Convenience charges cover platform services and are deducted from the seller's payment.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">11. Adjustments to Payment Terms</h4>
        <p className="text-gray-600 mb-2">Payment terms may be revised with mutual agreement after three months.</p>

        <h4 className="text-[10px] font-semibold text-gray-700">12. Legal Jurisdiction</h4>
        <p className="text-gray-600">Any disputes between the seller and the buyer must be resolved amicably. If a resolution cannot be reached, the dispute will be subject to the jurisdiction of Mumbai courts.</p>
        <p className="text-gray-600">This policy applies to materials, goods, tools, and equipment transactions. Separate policies apply to services provided through BuildPro-OGCS.</p>
      </div>

      {/* seller page for agreement */}
      <div className="container mx-auto p-6 text-xs relative bg-gray-100 min-h-screen"> {/* Small font size */}
        <h1 className="text-2xl font-bold text-gray-900 mb-6"> Sale BY Seller Page</h1>
        <div className="content-box p-4 border rounded-md bg-gray-100 relative text-[10px]">

          <h2 className="font-semibold">BuildPro-OGCS: Terms and Conditions for the Sale by Seller Module</h2>
          <p><strong>1. Visibility Charges:</strong> The seller must select one visibility option for their product, which can be from the following tiers:</p>
          <ul className="list-disc list-inside">
            <li>1X Visibility</li>
            <li>2X Visibility</li>
            <li>3X Visibility</li>
            <li>4X Visibility</li>
          </ul>
          <p>Visibility charges vary depending on the product category and the price of the product. A detailed chart of applicable charges will be provided to the seller.</p>
          <p>Additional options include 1X + Video, 3X + Video, and PowerPack Visibility with extra charges and These options come with additional applicable charges.</p>

          <p><strong>2. Sales Process and Payment Flow:</strong></p>
          <ul className="list-disc list-inside">
            <li>Product Listing: Once the product is listed, it will be available for buyers to view. When a buyer adds the product to their cart, the contact details of both the seller and the buyer will be shared.</li>
            <li>Buyer-Seller Interaction: After the contact details are shared, all further communication, negotiations, and the selling process will be handled directly between the seller and the buyer. BuildPro-OGCS will not be involved in the transaction after the product is listed.
            </li>
          </ul>
          <p><strong>3. Payment to Seller:</strong> </p>
          <li>The seller will receive payment directly from the buyer after the product purchase is completed. Alternatively, payment terms can be negotiated directly between the buyer and the seller.</li>
          <li>BuildPro-OGCS facilitates the connection between the seller and the buyer, but the seller is responsible for managing the transaction, payment collection, delivery, and all related processes.</li>
          <li>No Convenience Charges: No convenience charges are applicable for this module. Only the visibility charges selected by the seller will apply.</li>


          <p><strong>4. GST:</strong> GST will be applicable as per prevailing tax rates. The seller will charge GST separately from the product price, which will be included in the invoice.</p>

          <p><strong>5. Tax Invoices:</strong> The tax invoice for the product will be issued directly between the seller and the buyer, including both their addresses and the product details.</p>

          <p><strong>6.Optional Visibility Charges:</strong></p>
          <ul className="list-disc list-inside">
            <p>For enhanced visibility options, the following charges apply:</p>
            <li>1X + Video: Additional charge for video-based visibility to boost product attraction</li>
            <li>3X + Video: Enhanced video visibility for maximum reach.</li>
            <li>PowerPack Visibility: Premium visibility option, offering top placement on the website and streamlined product listing.</li>
            <p>These are optional and can be selected by the seller to increase product exposure.</p>
          </ul>
        </div>

        <div className="content-box mt-4 p-4 border rounded-md text-[10px]">
          <h3 className="font-semibold">Refund Terms and Conditions for the Seller Platform</h3>
          <p> 1. Registration Cancellation:</p>
          <ul className="list-disc list-inside">
            <li>Sellers or manufacturers who register with BuildPro-OGCS may cancel their registration; however, no refund will be applicable in such cases.</li>
          </ul>

          <p> 2. Registration Timeframe:</p>
          <ul className="list-disc list-inside">
            <li>Registration charges are valid for a period of three years. If a seller does not actively use the platform during this period, they may request a one-year grace period by submitting a written request. Upon approval, the seller can continue their registration.</li>
          </ul>

          <p>3. Cancellation Before Product Displayed on Platform:</p>
          <ul className="list-disc list-inside">
            <li>If a seller wishes to cancel a product or all products before they are displayed on the BuildPro-OGCS platform, a 10% administration charge will be deducted from the total Visibility Charges. The remaining balance will be refunded upon receiving a written cancellation request from the seller.</li>
          </ul>

          <p> 4. Cancellation After Product Displayed on Website:</p>
          <h4 className="font-semibold mt-2">If a product has been displayed on the BuildPro-OGCS platform, the following refund policy applies for cancellations during the first year:</h4>
          <ul className="list-disc list-inside">
            <li>Within 1 week: A 12% deduction from the total Visibility Charges.</li>
            <li>After 1 week but within 3 months: A 50% deduction from the total Visibility Charges.</li>
            <li>After 3 months but within 6 months: A 75% deduction from the total Visibility Charges.</li>
            <li>After 6 months: No refund will be applicable.</li>
            <li>If the product remains unsold or the seller is not connected with at least three prospective buyers within one year, BuildPro-OGCS will take responsibility and initiate a 90% refund of the Visibility Charges. This refund will be processed within 15 working days after the completion of one year.

            </li>
          </ul>

          <p> 5. Cancellation Due to Force Majeure:</p>
          <ul className="list-disc list-inside">
            <li>In the event of force majeure (e.g., government bans, legal restrictions), no cancellation or refund will be possible.</li>
            <li>If a product is found to be involved in unlawful activities, BuildPro-OGCS will immediately cancel the listing, and no refund will be issued. The seller will be solely responsible for any legal consequences, penalties, or fees arising from such activities.</li>
            <p>These terms and conditions are designed to ensure a clear and smooth transaction process between BuildPro-OGCS, the sellers, and the buyers, while maintaining transparency and compliance with applicable laws.</p>
          </ul>
        </div>

        <div className="content-box mt-4 p-4 border rounded-md text-[10px]">
          <h3 className="font-semibold">Sale by Seller</h3>
          <p>Full Control with BuildPro OGCS’s Powerful Marketing Support
            This module is perfect for manufacturers who want to control their sales but leverage BuildPro OGCS's powerful markeing tools. You handle the sales and transactions, and we ensure your products are seen by the right buyers.
          </p>

          <h4 className="font-semibold mt-2">How It Works:</h4>
          <ul className="list-disc list-inside">
            <p>Registration :</p>
            <li>Registration per seller (irrespective of product quantity or amount).</li>
            <p>Visibility Options: </p>
            <li>Choose from our visibility tiers to determine how prominently your products appear on the platform. </li>

            <p>Direct Inquiries :</p>
            <li>Buyers contact you directly to negotiate and place orders.</li>

            <p>Order Fulfillment: </p>
            <li>You manage all sales, delivery, and after-sales support.</li>

            <p>Genuine Customer: </p>
            <li>we provide you with genuine clients as compared to other e-commerce sites, you will get refined, genuine clients. No leads will come from other categories. Along with that, you can assess based on the product specifications and decide whether you want to purchase a particular product or not</li>
          </ul>



          <h4 className="font-semibold mt-2">Visibility Modules :</h4>
          <ul className="list-disc list-inside">
            <p>Our visibility modules (1X, 2X, 3X, and 4X) allow you to customize how prominently your products appear to buyers on the platform:</p>
            <li>1X Visibility: Basic listing, ideal for those looking for standard visibility</li>
            <li>2X Visibility: Enhanced exposure, making your product more noticeable to buyers.</li>
            <li>3X Visibility: Premium visibility, attracting a larger audience for high-demand products.</li>
            <li>4X Visibility: Maximum exposure, ensuring your products stand out to a wide audience of serious buyers</li>
          </ul>

          <h4 className="font-semibold mt-2">Video Ad Options:</h4>
          <p>For sellers with innovative products, add a short promotional video to your visibility package for extra engagement. Videos can significantly increase buyer interest by showcasing product features effectively.</p>

          <h4 className="font-semibold mt-2">Additional Visibility for Innovative Products :</h4>
          <p>For new and groundbreaking products, BuildPro OGCS offers exclusive video-based visibility options to enhance engagement and attract more attention from potential </p>

          <h4 className="font-semibold mt-2">Additional Visibility for Innovative Products</h4>
          <p>Additional Visibility</p>
          <li>Visibility Tiers + Fulfilments</li>
          <p>3X Visibility + Video Ad: This will be visible to customer those are searching the similar product, in small window. This visibility is more suitable those who wants to attract more buyers</p>
          <p>1X Visibility + Video Ad. :This will be visible to Web visitor in small window . Ideal for new innovative product</p>
          <p>Power pack Images Visibility : Details of product and when product With image scrolling when web visitor visited the site when click on image directed to product details this as per visibility module selected.</p>

          <li>For Innovative Products: Additional visibility options are available:</li>
          <p>1X + Video and 3X + Video, with charges based on product type and client requirements, providing extra exposure to your innovative offerings.( SHORT VIDEO)</p>

          <li>For Innovative Products: You can enhance your product's exposure with additional visibility</li>
          <p>1X + Video and 3X + Video, tailored to product type and buyer requirements. </p>

          <li>Power pack Visibility Image visibility: Fast forward your selling and product visit.</li>

          <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4>
          <p> <strong>1) Master’s In Industry: </strong>For Product Value ₹500000/- and above (Ideal for Equipment, seat of form work material, Bulk material, cement steel etc. </p>
          {/* <h3>For Product Value ₹500000/- and above (Ideal for Equipment, seat of form work material, Bulk material, cement steel etc.)</h3> */}
          <ul className="list-disc list-inside">
            <li>1X Visibility: ₹110000/year </li>
            <li>2X Visibility: ₹121000/year </li>
            <li>3X Visibility: ₹133100/year </li>
            <li>4X Visibility: ₹146400/year </li>
            <p>Visibility Tiers (choose based on your business needs): The above charges are applicable for registering 1 to 3 products</p>
          </ul>

          <p>For example, if Agency X registers the following products:<br />
            1.	Product ‘A’ priced at ₹55,000 (10 units available, total ₹5,50,000)<br />
            2.	Product ‘B’ priced at ₹7,50,000<br />
            3.	Product ‘C’ priced at ₹12,65,000<br />
            The charges for 1X visibility for all three products combined will be ₹1,10,000 + GST.<br />
            If another product, ‘D’, priced at ₹11,25,000, is added, the total charges will be ₹1,10,000 +
            ₹1,10,000 + GST.<br />
            Additionally, up to two more products can be added without extra charges, if required.<br />
          </p>

          {/* <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4> */}
          <p> <strong>2)Key Industry Experts: </strong> For Product Value ₹200000/-and above up-to ₹500000/- Below (Ideal Equipment, seat of form-work material, Bulk material, cement steel etc.)
            Visibility Tiers (choose based on your business needs): </p>
          {/* <h3> </h3> */}
          <ul className="list-disc list-inside">
            <li>1X Visibility: ₹95000/year </li>
            <li>2X Visibility: ₹104500/year </li>
            <li>3X Visibility: ₹114950/year </li>
            <li>4X Visibility: ₹126445/year </li>
            <p>The above charges are applicable for registering 1 to 5 products.</p>
          </ul>

          <p>For example, if Agency X registers the following products:<br />
            1.	Product ‘A’ priced at ₹55,000 (4 units available, total ₹2,20,000)<br />
            2.	Product ‘B’ priced at ₹3,50,000<br />
            3.	Product ‘C’ priced at ₹4,65,000<br />
            4.	Product ‘D’ priced at ₹2,65,000<br />
            5.	Product ‘E’ priced at ₹2,05,000<br />
            The charges for 1X visibility for all Five products combined will be ₹95,000 + GST.<br />
            If another product, ‘F’, priced at ₹4,25,000, is added, the total charges will be ₹95,000 + ₹95,000 + GST. Additionally, up to Four more products can be added without extra charges, if required.
          </p>

          {/* <h4 className="font-semibold mt-2">"Visibility Charges by Price & Visibility Options." For Sale By Seller.</h4> */}
          <p> <strong>3)	Industry leader: </strong> For Product Value less than ₹200000/- (Ideal small Equipment, tools, plywood, small quantity bulk material, form-work items, special item, etc. ) </p>
          {/* <h3></h3> */}
          <ul className="list-disc list-inside">
            <p>Visibility Tiers (choose based on your business needs):</p>
            <li>1X Visibility: Rs. 4 x Product Value (Min ₹15000/- Maximum ₹90000/-)  </li>
            <li>2X Visibility: Rs. 6 x Product Value (Min ₹19500/- Maximum ₹99000/-) </li>
            <li>3X Visibility: Rs. 8 x Product Value(Min ₹25350/- Maximum ₹108900/-)  </li>
            <li>4X Visibility: Rs. 11 x Product Value(Min ₹32955/- Maximum ₹119790/-) </li>
            <p>The above charges are applicable for registering 1 to 8 products.</p>
          </ul>

          <p>For example, if Agency X registers the following products:<br />
            1.	Product ‘A’ priced at ₹100 (4 units available, total ₹400)<br />
            2.	Product ‘B’ priced at ₹3,300<br />
            3.	Product ‘C’ priced at ₹250 (2 units available, total ₹500)<br />
            4.	Product ‘D’ priced at ₹210 (5 units available, total ₹1,050)<br />
            5.	Product ‘E’ priced at ₹25 (2 units available, total ₹50)<br />
            6.	Product ‘F’ priced at ₹80 (4 units available, total ₹320)<br />
            7.	Product ‘G’ priced at ₹95<br />
            8.	Product ‘H’ priced at ₹3,950<br />
          </p>
          <p>The charges for 1X visibility for all eight products combined will be based on the highest value product, which is Product ‘H’ priced at ₹3,950. So, the total visibility charge for the service will be 4 times ₹3,950 = ₹15,800 + GST.</p>
          <p>If another product is added (e.g., Product ‘I’ priced at ₹15,000), the charges will be updated as follows:</p>
          <li>Total visibility charges = ₹60,000 + ₹15,000 + GST,</li>
          <li>Up to 7 more products can be added without incurring extra charges as long as the value of the new 6 products is less than ₹15,000. And, one product value should be less than ₹3750, However, if any additional product's value exceeds ₹15,000, the new product value will be considered for the charges.
          </li>

        </div>
      </div>


      {/* Confirm Agreement Checkbox */}
      <div className="flex items-center mt-6">
        <input
          type="checkbox"
          id="agree"
          checked={agree}
          onChange={handleAgreeChange}
          className="mr-2 w-4 h-4"
        />
        <label htmlFor="agree" className="text-gray-700 text-sm">
          I confirm that I have read and agree to the Terms and Conditions.
        </label>
      </div>

      {/* Proceed Button */}
      <button
        className={`mt-4 px-4 py-2 text-white rounded-lg ${agree ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
          }`}
        disabled={!agree}
        onClick={handleProceed}
      >
        Proceed
      </button>

    </div>
  );

  //   return (
  //    // <div className="container mx-auto p-6 text-xs">
  //         //    <button onClick={handleBack} className="mb-4 text-blue-500 text-xs underline">Go Back</button>
  //       //<h1 className="text-2xl font-bold text-gray-900 mb-6">OGCS Sale Page</h1>
  //       {expandedContent}
  //    // </div>
  //  );
};

export default OgcsSale;
